import { render, staticRenderFns } from "./salary-report.vue?vue&type=template&id=3b224503"
import script from "./salary-report.vue?vue&type=script&lang=js"
export * from "./salary-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports